import { Link } from "react-router-dom";
import { Calendar, MapPin, ArrowUpRight } from "lucide-react";

const formatDate = (iso) => {
  const d = new Date(iso);
  return d.toLocaleDateString("en-US", { month: "short", day: "2-digit", year: "numeric" });
};

export default function EventCard({ event, index = 0 }) {
  const remaining = event.capacity - event.seats_taken;
  const soldOutSoon = remaining > 0 && remaining <= Math.max(10, event.capacity * 0.1);

  return (
    <Link
      to={`/events/${event.slug}`}
      data-testid={`event-card-${event.slug}`}
      className="group block fade-up"
      style={{ animationDelay: `${index * 60}ms` }}
    >
      <div className="relative overflow-hidden border border-white/10 bg-white/[0.02] hover:border-white/30 transition-all duration-300">
        <div className="relative aspect-[4/3] overflow-hidden">
          <img
            src={event.image_url}
            alt={event.title}
            loading="lazy"
            className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-[#0A0A0A] via-transparent to-transparent" />
          <div className="absolute top-4 left-4 flex gap-2">
            <span className="px-3 py-1 bg-[#0A0A0A]/80 backdrop-blur-md text-white text-[10px] uppercase tracking-[0.2em] font-bold border border-white/10">
              {event.category}
            </span>
            {soldOutSoon && (
              <span className="px-3 py-1 bg-[#B4FF39] text-[#0A0A0A] text-[10px] uppercase tracking-[0.2em] font-bold">
                Almost Out
              </span>
            )}
          </div>
          <div className="absolute bottom-4 right-4 w-9 h-9 bg-[#B4FF39] flex items-center justify-center opacity-0 group-hover:opacity-100 translate-y-2 group-hover:translate-y-0 transition-all">
            <ArrowUpRight className="w-4 h-4 text-[#0A0A0A]" />
          </div>
        </div>

        <div className="p-6 space-y-4">
          <h3 className="font-display text-xl md:text-2xl leading-[1.05] tracking-tight">
            {event.title}
          </h3>
          <div className="flex items-center gap-4 text-xs text-zinc-400 uppercase tracking-[0.15em]">
            <span className="flex items-center gap-1.5">
              <Calendar className="w-3.5 h-3.5 text-[#B4FF39]" />
              {formatDate(event.date)}
            </span>
            <span className="flex items-center gap-1.5">
              <MapPin className="w-3.5 h-3.5 text-[#B4FF39]" />
              {event.city}
            </span>
          </div>
          <div className="flex items-end justify-between pt-3 border-t border-white/5">
            <div>
              <p className="text-[10px] tracking-[0.2em] uppercase text-zinc-500">From</p>
              <p className="font-display text-lg">${event.price_from.toFixed(0)}</p>
            </div>
            <p className="text-[10px] tracking-[0.2em] uppercase text-zinc-500 font-mono-tight">
              {remaining > 0 ? `${remaining} left` : "Sold Out"}
            </p>
          </div>
        </div>
      </div>
    </Link>
  );
}
